(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header__common-js"] && !Shopify.designMode) return;
  try {
    (function () {
    const MOBILE_MAX = 767;

    function removeUserButtonOnMobile() {
      // Only run on mobile widths
      if (window.innerWidth > MOBILE_MAX) return;

      const header = document.querySelector('.page__header--desktop');
      if (!header) return;

      const userBtn = header.querySelector('.user__button');
      if (!userBtn) return;

      userBtn.remove();
    }

    function bindMobileOverlayClose() {
      if (window.innerWidth > MOBILE_MAX) return;

      // Bind once globally (safe even if DOM changes)
      if (document.documentElement.dataset.userOverlayBound === '1') return;
      document.documentElement.dataset.userOverlayBound = '1';

      // Use CAPTURE to beat <label for="..."> default toggle
      document.addEventListener(
        'click',
        function (e) {
          const overlay = e.target.closest(
            '.page__header--mobile .user__button label.overlay'
          );
          if (!overlay) return;

          // Stop label's default "toggle checkbox" behavior
          e.preventDefault();
          e.stopPropagation();

          const userBtn = overlay.closest('.user__button');
          if (!userBtn) return;

          const checkbox = userBtn.querySelector('input[type="checkbox"]');
          if (!checkbox) return;

          checkbox.checked = false;
        },
        true // <-- capture is important here
      );
    }

    // Run after DOM is ready
    function init() {
      removeUserButtonOnMobile();
      bindMobileOverlayClose();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Optional: if user rotates / resizes into mobile after load
    window.addEventListener('resize', function () {
      removeUserButtonOnMobile();
      bindMobileOverlayClose();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-block__product-page--swatch"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'DOMContentLoaded',
    () => {
      const qtyInput = document.getElementById('packQuantity');
      const container = document.querySelector('.select__flavour');
      if (!qtyInput || !container) return;

      // Use the first flavour__item as a template
      const baseItem = container.querySelector('.flavour__item');
      if (!baseItem) return;

      // Clean clone helper
      const cloneItem = (idx) => {
        const item = baseItem.cloneNode(true);

        // Reset any prior state
        item.style.backgroundImage = '';
        item.classList.remove('is-selected');

        // Ensure there is exactly one hidden input per item, with the correct name
        let hidden = item.querySelector('input[type="hidden"][name^="flavour-item-"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          item.prepend(hidden);
        }
        hidden.name = `flavour-item-${idx}`;
        hidden.value = ''; // empty until user chooses a variant

        // Optional: update the prompt copy
        const label = item.querySelector('small');
        if (label) label.textContent = `SHAKE ${idx}`;

        return item;
      };

      // Render to match the quantity
      const renderFlavourItems = () => {
        const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

        // If container is empty, seed it with a clean baseItem
        if (!container.children.length) {
          container.appendChild(cloneItem(1));
        }

        // Grow
        while (container.children.length < qty) {
          const idx = container.children.length + 1;
          container.appendChild(cloneItem(idx));
        }

        // Shrink
        while (container.children.length > qty) {
          container.removeChild(container.lastElementChild);
        }

        // Re-index names (in case qty changed downward)
        [...container.querySelectorAll('.flavour__item')].forEach((item, i) => {
          const idx = i + 1;
          const hidden = item.querySelector('input[type="hidden"][name^="flavour-item-"]');
          if (hidden) hidden.name = `flavour-item-${idx}`;
          const label = item.querySelector('small');
          if (label) label.textContent = `SHAKE ${idx}`;
        });
      };

      // Delete handler (event delegation)
      container.addEventListener('click', (e) => {
        const btn = e.target.closest('.delete__selected_flavour');
        if (!btn) return;

        const item = btn.closest('.flavour__item');
        if (!item) return;

        // 1) Remove the hidden input (the “selected flavour”)
        const hidden = item.querySelector('input[type="hidden"][name^="flavour-item-"]');
        if (hidden) hidden.remove();

        // 2) Clear any inline background image
        item.style.backgroundImage = '';

        // 3) Optional: clear “selected” state + reset label
        item.classList.remove('is-selected');
        // const label = item.querySelector('small');
        // if (label) label.textContent = 'SELECT FLAVOUR';
      });

      // Listen for quantity changes (both user and programmatic)
      const onQtyChange = () => renderFlavourItems();
      qtyInput.addEventListener('change', onQtyChange);
      qtyInput.addEventListener('input', onQtyChange);

      // Fallback: observe attribute changes if some script mutates value without events
      const mo = new MutationObserver(() => renderFlavourItems());
      mo.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

      // Initial render
      renderFlavourItems();

      // === Swatch → Flavour slot assignment ===
      // === Swatch → Flavour slot assignment (duplicates allowed) ===
      const swatchHolder = document.querySelector('.product__swatches .swatches__holder');
      if (swatchHolder) {
        const getBgFromSwatch = (el) => {
          const inlineBg = el.style.backgroundImage;
          if (inlineBg && inlineBg !== 'none') return inlineBg;
          const comp = window.getComputedStyle(el);
          return comp.backgroundImage && comp.backgroundImage !== 'none' ? comp.backgroundImage : '';
        };

        const getAllSlots = () => [...container.querySelectorAll('.flavour__item')];
        const ensureHidden = (slot) => {
          let hidden = slot.querySelector('input[type="hidden"][name^="flavour-item-"]');
          if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'flavour-item-temp'; // will be re-indexed by your render function
            slot.prepend(hidden);
          }
          return hidden;
        };
        const isSlotEmpty = (slot) => {
          const hidden = slot.querySelector('input[type="hidden"][name^="flavour-item-"]');
          return !hidden || !hidden.value;
        };
        const findFirstEmptySlot = () => getAllSlots().find(isSlotEmpty);
        const nudge = (el) => {
          el.style.transition = 'transform 120ms ease';
          el.style.transform = 'scale(0.98)';
          setTimeout(() => {
            el.style.transform = 'scale(1)';
          }, 120);
        };

        swatchHolder.addEventListener('click', (e) => {
          const swatch = e.target.closest('.swatch--color');

          if (!swatch) return;
          if (swatch.dataset.swatchSoldout === 'true') return;

          const variantId = swatch.dataset.variantid;
          if (!variantId || qtyInput.value <= 1) return;

          // Make sure slots match current pack quantity (uses your existing function)
          if (typeof renderFlavourItems === 'function') renderFlavourItems();

          // Fill the next empty slot (duplicates allowed)
          const emptySlot = findFirstEmptySlot();
          if (!emptySlot) {
            // No empty slots left; gently hint
            console.warn('All flavour slots are filled. Increase pack quantity to add more.');
            nudge(container.lastElementChild || container);
            return;
          }

          const hidden = ensureHidden(emptySlot);
          hidden.value = String(variantId);

          emptySlot.style.backgroundImage = getBgFromSwatch(swatch) || '';
          emptySlot.classList.add('is-selected');

          nudge(emptySlot);
        });
      }

      // When a flavour is cleared via the delete button in your existing handler,
      // that slot becomes "empty" again, so the next swatch click will fill it.
    },
    { once: true }
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-product__bags"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const packQtyHidden = document.getElementById('packQuantity');
    const secId = document.querySelector('[data-sec-id]');

    // -------------------------
    // Helpers
    // -------------------------
    const formatMoney = (cents) => {
      const n = Math.round(Number(cents) || 0);

      // Use Shopify formatter if available
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme?.moneyFormat) {
        return Shopify.formatMoney(n, theme.moneyFormat);
      }

      // Fallback: simple $xx.xx
      return `$${(n / 100).toFixed(2)}`;
    };

    // Parse "$316.00", "A$316.00", "316,00", etc → cents
    const parseMoneyToCents = (str) => {
      if (str == null) return NaN;
      let s = String(str).trim();
      s = s.replace(/[^\d.,-]/g, ''); // keep only digits/.,-
      if (s.includes('.') && s.includes(',')) s = s.replace(/,/g, '');
      if (!s.includes('.') && s.includes(',')) s = s.replace(',', '.');
      const n = parseFloat(s);
      return Number.isFinite(n) ? Math.round(n * 100) : NaN;
    };

    // Your current pack selector info
    const getSelectedPack = () => {
      const checked = document.querySelector('input[name="pack"]:checked');
      if (!checked) return null;

      const label = checked.closest('label');
      const qty = parseInt(checked.value, 10) || 1;

      // discountedTotal is expected in cents
      const discountedTotal = Math.round(parseFloat(label?.dataset.discountedTotal || '0'));

      const subscriptionPercent = parseFloat(label?.dataset.subscriptionPercent || '0'); // %

      const originalTotal = label?.dataset.originalPrice || ''; // string like "$79.00"

      return { qty, discountedTotal, originalTotal, subscriptionPercent, label };
    };

    // Get Recharge widget root (shadow DOM aware)
    const getRechargeRoot = () => {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget) return null;

      // If Recharge uses open shadow root, this will work.
      // If it's closed, we can't access it (browser limitation).
      return widget.shadowRoot || widget;
    };

    // -------------------------
    // PRICE OVERRIDE LOGIC (Recharge)
    // -------------------------
    const updateRechargePrices = () => {
      const sel = getSelectedPack();
      if (!sel) return;

      const { qty, discountedTotal, subscriptionPercent, originalTotal } = sel;

      // Keep hidden quantity in sync with selected pack
      if (packQtyHidden) {
        packQtyHidden.value = String(qty);
      }

      // Your pack "one-time" total (cents)
      const otpPriceCents = Math.round(discountedTotal || 0);

      // Base original price for compare / strike-through
      const originalCents = parseMoneyToCents(originalTotal);
      const subCompareCents = Number.isFinite(originalCents) ? originalCents : otpPriceCents;

      // Subscription price = pack discountedTotal with extra % off
      const subPriceCents = Math.round(otpPriceCents * (1 - (subscriptionPercent || 0) / 100));

      const root = getRechargeRoot();
      if (!root) return;

      // -----------------------------
      // 1️⃣ ONE-TIME purchase UI
      // -----------------------------
      const otpOption = root.querySelector('.rc-purchase-option.rc-selection__onetime');
      if (otpOption) {
        const pricesWrapper = otpOption.querySelector('.rc-purchase-option__prices');
        if (pricesWrapper) {
          // Main one-time price
          let otpPriceEl = pricesWrapper.querySelector('[part="rc-purchase-option__price"]');
          if (!otpPriceEl) {
            otpPriceEl = document.createElement('span');
            otpPriceEl.className = 'rc-price';
            otpPriceEl.setAttribute('part', 'rc-purchase-option__price');
            pricesWrapper.appendChild(otpPriceEl);
          }
          otpPriceEl.textContent = formatMoney(otpPriceCents);

          // Strike-through original for one-time
          let otpOriginalEl = pricesWrapper.querySelector('[data-otp-original-price]');
          if (!otpOriginalEl) {
            otpOriginalEl = document.createElement('span');
            otpOriginalEl.className = 'rc-price strike-through text-muted';
            otpOriginalEl.setAttribute('part', 'rc-purchase-option__original-price');
            otpOriginalEl.setAttribute('data-otp-original-price', '');
            // Insert before the main price so the layout matches subscription
            pricesWrapper.insertBefore(otpOriginalEl, otpPriceEl);
          }

          if (qty >= 2 && Number.isFinite(subCompareCents)) {
            otpOriginalEl.textContent = formatMoney(subCompareCents);
            otpOriginalEl.style.display = '';
          } else {
            otpOriginalEl.style.display = 'none';
          }
        }
      }

      // -----------------------------
      // 2️⃣ SUBSCRIPTION UI
      // -----------------------------
      root
        .querySelectorAll('.rc-purchase-option.rc-purchase-option__subscription .rc-purchase-option__prices')
        .forEach((pricesWrapper) => {
          let originalEl = pricesWrapper.querySelector('[part="rc-purchase-option__original-price"]');
          let discountedEl = pricesWrapper.querySelector('[part="rc-purchase-option__discounted-price"]');

          // If discounted element doesn't exist, build the layout:
          // - Ensure an original (strike-through) element
          // - Create a discounted element
          if (!discountedEl) {
            // Ensure original element exists
            if (!originalEl) {
              originalEl = document.createElement('span');
              originalEl.className = 'rc-price strike-through text-muted';
              originalEl.setAttribute('part', 'rc-purchase-option__original-price');
              pricesWrapper.appendChild(originalEl);
            } else {
              // Make sure it visually matches OTP strike-through
              originalEl.classList.add('strike-through', 'text-muted');
            }

            // Create discounted element
            discountedEl = document.createElement('span');
            discountedEl.className = 'rc-price';
            discountedEl.setAttribute('part', 'rc-purchase-option__discounted-price');
            pricesWrapper.appendChild(discountedEl);
          }

          // At this point we know discountedEl exists, and originalEl should too
          if (!originalEl) {
            // As a safety fallback, create original if still missing
            originalEl = document.createElement('span');
            originalEl.className = 'rc-price strike-through text-muted';
            originalEl.setAttribute('part', 'rc-purchase-option__original-price');
            pricesWrapper.insertBefore(originalEl, discountedEl);
          }

          // Apply prices
          if (Number.isFinite(subCompareCents)) {
            originalEl.textContent = formatMoney(subCompareCents);
            originalEl.style.display = '';
          } else {
            originalEl.style.display = 'none';
          }

          if (discountedEl) {
            discountedEl.textContent = formatMoney(subPriceCents);
          }
        });
    };

    const deferUpdate = () => setTimeout(updateRechargePrices, 0);

    // -------------------------
    // EVENT BINDINGS
    // -------------------------

    // Pack radios → recalc prices
    const bindPackListeners = () => {
      document.querySelectorAll('input[name="pack"]').forEach((el) => {
        el.removeEventListener('change', deferUpdate);
        el.addEventListener('change', deferUpdate);
      });
    };

    bindPackListeners();

    // Variant swatches: you already had renderSections logic; keep it,
    // just make sure you call updateRechargePrices after sections update.

    const swatchHolder = document.querySelector('.product__swatches .swatches__holder');
    if (swatchHolder) {
      swatchHolder.addEventListener('click', (e) => {
        const swatch = e.target.closest('.swatch--color[data-variantid]');
        if (!swatch || swatch.dataset.swatchSoldout === 'true') return;
        const variantId = swatch.dataset.variantid;
        renderSections({ variantId });
      });
    }

    async function renderSections({ variantId = null } = {}) {
      const sections = getSectionsToRender();
      if (!sections.length) return;

      const ids = sections.map((s) => s.id).join(',');
      const url = new URL(window.location.href);
      url.searchParams.set('sections', ids);
      if (variantId) url.searchParams.set('variant', String(variantId));

      let json;
      try {
        const res = await fetch(url.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          cache: 'no-store',
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        json = await res.json();
      } catch (err) {
        console.error('Section render fetch failed:', err);
        return;
      }

      sections.forEach(({ id, container, selector }) => {
        const html = json[id];
        if (!html) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');

        const mount =
          (container && document.querySelector(container)) || document.getElementById(`shopify-section-${id}`);

        if (!mount) return;

        if (selector) {
          const newPart = doc.querySelector(selector);
          const oldPart = mount.querySelector(selector);
          if (newPart && oldPart) {
            oldPart.replaceWith(newPart);
          } else {
            mount.innerHTML = html;
          }
        } else {
          mount.innerHTML = html;
        }
      });

      document.dispatchEvent(new CustomEvent('sections:updated'));
    }

    function getSectionsToRender() {
      return [
        {
          id: secId.dataset.secId, // update to your real section id
          selector: '.variant-images',
        },
        {
          id: secId.dataset.secId, // update to your real section id
          selector: '.mobile-variant-images',
        },
      ];
    }

    // When sections re-render (e.g. variant change), re-bind pack listeners
    // and re-run the price override (Recharge widget might re-mount).
    document.addEventListener('sections:updated', () => {
      bindPackListeners();
      deferUpdate();
    });

    // Initial run – wait until Recharge widget + subscription prices exist
    const initRechargeOverride = () => {
      const root = getRechargeRoot();
      const hasSubPrices =
        root && root.querySelector('.rc-purchase-option.rc-purchase-option__subscription .rc-purchase-option__prices');

      if (!hasSubPrices) {
        // Try again on the next frame
        requestAnimationFrame(initRechargeOverride);
        return;
      }

      // Now we know subscription UI exists → safe to apply overrides
      deferUpdate();
    };

    initRechargeOverride();
  });
  } catch(e) { console.error(e); }
})();

})();
